import { stringfy_post } from '@/utils/http'
import { URLS } from './constant'
import { GROUPS } from './permission'

const MENU_DATA = [
  {
    path: '',
    title: '工作台',
    children: [
      {
        path: '/index',
        title: '搜索入口',
        userGroups: [GROUPS.ADMIN]
      },
      {
        path: '/dark-text',
        title: '暗文内容',
        userGroups: [GROUPS.CONFIGUE, GROUPS.ADMIN]
      },
      {
        path: '/hot',
        title: '热门搜索',
        userGroups: [GROUPS.CONFIGUE, GROUPS.ADMIN]
      },
      {
        path: '/black-list',
        title: '黑名单',
        userGroups: [GROUPS.CONFIGUE, GROUPS.ADMIN]
      },
      {
        path: '/proper-noun',
        title: '专有名词',
        userGroups: [GROUPS.CONFIGUE, GROUPS.ADMIN]
      },
      {
        path: '/keywords',
        title: '关键词补充',
        userGroups: [GROUPS.CONFIGUE, GROUPS.ADMIN]
      },
      {
        path: '/run-setting',
        title: '运营活动关键词',
        userGroups: [GROUPS.CONFIGUE, GROUPS.ADMIN]
      }
    ]
  },
  {
    path: '',
    title: '系统管理',
    children: [
      {
        path: '/settings/permission',
        title: '权限管理',
        userGroups: [GROUPS.ADMIN]
      },
      {
        path: '/settings/user',
        title: '用户管理',
        userGroups: [GROUPS.ADMIN]
      }
    ]
  }
]

function matchGroups(g1: string[], g2: string[]) {
  for (let g1Item of g1) {
    if (g2.includes(g1Item)) return true
  }
  return false
}

function getFilteredMenuData(groups: string[]) {
  return MENU_DATA.map((menuItem) => {
    let ret = { ...menuItem }
    ret.children = ret.children.filter((item) => matchGroups(item.userGroups, groups))
    return ret
  }).filter((menuItem) => menuItem.children.length > 0)
}

function getCurrentPath(path: string, groups: string[]): { path: string; title: string }[] {
  let ret: { path: string; title: string }[] = []
  ret.push({ path: '', title: '首页' })
  for (let group of getFilteredMenuData(groups)) {
    for (let item of group.children) {
      // if (item.path == path || (item.subs && item.subs.includes(path))) {
      //   ret.push({ path: group.path, title: group.title })
      //   ret.push({ path: '/csearch' + item.path, title: item.title })
      //   return ret
      // }
      if (item.path == path) {
        ret.push({ path: group.path, title: group.title })
        ret.push({ path: '/csearch' + item.path, title: item.title })
        return ret
      }
    }
  }
  return ret
}

// 菜单中高亮的url
function getMatchPath(path: string, groups: string[]) {
  for (let group of getFilteredMenuData(groups)) {
    for (let item of group.children) {
      // if (item.path == path || (item.subs && item.subs.includes(path))) {
      //   return item.path
      // }
      if (item.path == path) {
        return item.path
      }
    }
  }
  return path
}

function getOpenKeys(path: string, groups: string[]): string[] {
  for (let group of getFilteredMenuData(groups)) {
    if (group.children.map((item) => item.path).includes(path)) {
      return [group.title]
    }
  }
  return ['工作台']
}

// function getConstants() {
//   return stringfy_post(URLS.GET_CONSTANTS, {})
// }

export { getCurrentPath, getOpenKeys, getMatchPath, getFilteredMenuData }
